export const CURRICULUM_TYPE_MYP = "IB_MYP";
export const CURRICULUM_TYPE_PYP = "IB_PYP";
export const CURRICULUM_TYPE_UBD = "UBD";
export const CURRICULUM_TYPE_DP = "IB_DP";
export const CURRICULUM_VARIANT_CGC = "CGC";
export const CURRICULUM_VARIANT_AUSC = "AUSC";
export const CURRICULUM_VARIANT_CAMBRIDGE = "CAMBRIDGE";
export const CURRICULUM_VARIANT_ENC = "ENC";
export const CURRICULUM_VARIANT_ENC_GCSE = "ENC_GCSE";
export const CURRICULUM_VARIANT_ENC_ALEVEL = "ENC_A_LEVEL";
export const CURRICULUM_VARIANT_OPEN = "OPEN";
export const CURRICULUM_VARIANT_TODDLE_PLAY = "TODDLE_PLAY";
export const CURRICULUM_VARIANT_WAC_K10 = "WAC";
export const CURRICULUM_VARIANT_WACE = "WACE";

// Entity Types
export const ENTITY_TYPE_PYP_PLANNER_ELEMENT = "PYP_PLANNER_ELEMENT";
export const ENTITY_TYPE_PLANNER_BENCHMARK = "PLANNER_BENCHMARK";
export const ENTITY_TYPE_PLANNER_ELEMENT_NODE = "PLANNER_ELEMENT_NODE";

// Registration Categories
export const CATEGORY_DIPLOMA = "DIPLOMA";
export const CATEGORY_COURSE = "COURSE";
export const CATEGORY_OTHERS = "OTHERS";
export const CATEGORY_CAREER_RELATED_CERTIFICATE = "CAREER_RELATED_CERTIFICATE";
export const CATEGORY_ANTICIPATED = "ANTICIPATED";

//Node types
export const NODE_TYPE_IB_PYP_CURRICULUM_PROGRAM = "IB_PYP_CURRICULUM_PROGRAM";
export const NODE_TYPE_IB_MYP_CURRICULUM_PROGRAM = "IB_MYP_CURRICULUM_PROGRAM";
export const NODE_TYPE_UBD_CURRICULUM_PROGRAM = "UBD_CURRICULUM_PROGRAM";
export const NODE_TYPE_IB_DP_CURRICULUM_PROGRAM = "IB_DP_CURRICULUM_PROGRAM";

//Planner element types
export const PLANNER_ELEMENT = "PLANNER_ELEMENT";
export const PLANNER_ELEMENT_DP_CAS_STRANDS = "DP_CAS_STRANDS";
export const PLANNER_ELEMENT_DP_CAS_SERVICE_TYPES = "DP_CAS_SERVICE_TYPES";
export const PLANNER_ELEMENT_DP_CAS_APPROACHES = "DP_CAS_APPROACHES";
export const PLANNER_ELEMENT_DP_CAS_LEARNING_OUTCOMES =
  "DP_CAS_LEARNING_OUTCOMES";
export const PLANNER_ELEMENT_DP_CP_SL_LEARNING_OUTCOMES =
  "DP_CP_SL_LEARNING_OUTCOMES";
export const PLANNER_ELEMENT_DP_CP_CE_LEARNING_OUTCOMES =
  "CE_LEARNING_OUTCOMES";
export const PLANNER_ELEMENT_SAA_LEARNING_OUTCOMES =
  "MYP_SERVICE_ACTION_OUTCOME";
export const PLANNER_ELEMENT_DP_CP_SL_STRANDS = "DP_CP_SL_STRANDS";
export const PLANNER_ELEMENT_DP_CP_SL_APPROACHES = "DP_CP_SL_APPROACHES";
export const PLANNER_ELEMENT_COMMUNITY_ENGAGEMENT_DIMENSIONS = "CE_DIMENSIONS";
export const PLANNER_ELEMENT_COMMUNITY_ENGAGEMENT_STAGES = "CE_STAGES";
export const PLANNER_ELEMENT_COMMUNITY_ENGAGEMENT_PRINCIPLES = "CE_PRINCIPLES";

export const PLANNER_ELEMENT_MYP_GLOBAL_CONTEXT = "MYP_GLOBAL_CONTEXT";

export const PLANNER_ELEMENT_MYP_SERVICE_ACTION_TYPE =
  "MYP_SERVICE_ACTION_TYPE";
export const PLANNER_ELEMENT_MYP_SERVICE_ACTION_OUTCOME =
  "MYP_SERVICE_ACTION_OUTCOME";

//unitTypes
export const PYP_SUBJECT_SPECIFIC = "ibStandAlone";
export const PYP_TRANSDISCIPLINARY = "ibInquiry";

//Subject Constants
export const SUBJECT_NAME_ENVIRONMENTAL_SYSTEMS_SOCIETIES =
  "Environmental systems and societies";

export const ELEMENT_TYPE_PYP_LEARNING_STANDARD = "PYP_LEARNING_STANDARD";
export const ELEMENT_TYPE_MYP_LEARNING_STANDARD = "MYP_LEARNING_STANDARD";
export const ELEMENT_TYPE_UBD_LEARNING_STANDARD = "UBD_LEARNING_STANDARD";
export const ELEMENT_TYPE_DP_LEARNING_STANDARD = "DP_SUBJECT_STANDARD";

export const ELEMENT_TYPE_PYP_KEY_CONCEPT = "PYP_KEY_CONCEPT";
export const ELEMENT_TYPE_MYP_KEY_CONCEPT = "MYP_KEY_CONCEPT";
export const ELEMENT_TYPE_UBD_KEY_CONCEPT = "UBD_KEY_CONCEPT";
export const ELEMENT_TYPE_UBD_FOCUS_AREA = "UBD_FOCUS_AREA";
export const ELEMENT_TYPE_MYP_FOCUS_AREA = "MYP_FOCUS_AREA";
export const ELEMENT_TYPE_PYP_LEARNER_PROFILE = "PYP_LEARNER_PROFILE";
export const ELEMENT_TYPE_MYP_LEARNER_PROFILE = "MYP_LEARNER_PROFILE";
export const ELEMENT_TYPE_UBD_LEARNER_PROFILE = "UBD_LEARNER_PROFILE";
export const ELEMENT_TYPE_DP_LEARNER_PROFILE = "DP_LEARNER_PROFILE";
export const ELEMENT_TYPE_UbD_THEME = "UBD_THEME";
export const ELEMENT_TYPE_PYP_RELATED_CONCEPT = "PYP_RELATED_CONCEPT";
export const ELEMENT_TYPE_MYP_RELATED_CONCEPT = "MYP_RELATED_CONCEPT";
export const ELEMENT_TYPE_MYP_SPECIFIED_CONCEPT = "MYP_SPECIFIED_CONCEPTS";
export const ELEMENT_TYPE_UBD_RELATED_CONCEPT = "UBD_RELATED_CONCEPT";
export const ELEMENT_TYPE_PYP_ATL = "PYP_ATL";
export const ELEMENT_TYPE_MYP_ATL = "MYP_ATL";
export const ELEMENT_TYPE_UBD_ATL = "UBD_ATL";
export const ELEMENT_TYPE_UBD_SKILL = "UBD_SKILL";
export const ELEMENT_TYPE_DP_ATL = "DP_ATL";
export const ELEMENT_TYPE_PYP_ACTION = "PYP_ACTION";
export const ELEMENT_TYPE_MYP_OBJECTIVES = "MYP_OBJECTIVES";
export const ELEMENT_TYPE_PERSONAL_OBJECTIVES = "PERSONAL_OBJECTIVES";
export const ELEMENT_TYPE_COMMUNITY_OBJECTIVES = "COMMUNITY_OBJECTIVES";
export const ELEMENT_TYPE_DP_OBJECTIVES = "DP_OBJECTIVES";
export const ELEMENT_TYPE_MYP_SUBJECT = "MYP_SUBJECT";
export const ELEMENT_TYPE_MYP_PROJECT = "MYP_PROJECT";
export const ELEMENT_TYPE_UBD_SUBJECT = "UBD_SUBJECT";
export const ELEMENT_TYPE_UBD_COURSE = "LEARNING_COURSE";
export const ELEMENT_TYPE_PYP_SUBJECT = "PYP_SUBJECT";
export const ELEMENT_TYPE_DP_SUBJECT = "DP_SUBJECT";
export const IB_PYP_ELEMENT_TYPE_DP = "DP_CRITERIA";
export const ELEMENT_TYPE_UNIT_PLAN = "UNIT_PLAN";
export const UBD_SUBJECT_SPECIFIC = "ubdSubjectSpecific";
export const UBD_INQUIRY = "ubdInquiry";
export const ELEMENT_TYPE_MYP_SERVICE_ACTION_OUTCOME =
  "MYP_SERVICE_ACTION_OUTCOME";
export const MYP_INTERDISCIPLINARY = "ibMYPInterdisciplinary";
export const ASSESSMENT_TYPE_QUICK_TASK = "QUICK_TASK";
export const GROUP_TYPE_WORKSHEET = "WORKSHEET";
export const ELEMENT_TYPE_DP_SYLLABUS = "DP_SYLLABUS";
export const ELEMENT_TYPE_DP_SUBJECT_STANDARD = "DP_SUBJECT_STANDARD";
export const ELEMENT_TYPE_DP_KNOWLEDGE_FRAMEWORK = "DP_KNOWLEDGE_FRAMEWORK";
export const ELEMENT_TYPE_PYP_THEME = "PYP_THEME";
export const ELEMENT_TYPE_PYP_FOCUS_AREA = "PYP_FOCUS_AREA";
export const ELEMENT_TYPE_DP_CAS_LEARNING_OUTCOMES = "DP_CAS_LEARNING_OUTCOMES";
export const ELEMENT_TYPE_DP_CP_SL_LEARNING_OUTCOMES =
  "DP_CP_SL_LEARNING_OUTCOMES";
export const ELEMENT_TYPE_DP_CP_PPS_LEARNING_OUTCOMES =
  "DP_CP_PPS_LEARNING_OUTCOMES";
export const ELEMENT_TYPE_CP_SL_LEARNING_OUTCOMES = "CP_SL_LEARNING_OUTCOMES";
export const ELEMENT_TYPE_DP_CAS_LEARNING_OUTCOME = "DP_CAS_LEARNING_OUTCOME";
export const ELEMENT_TYPE_DP_TOK = "DP_TOK";
export const ELEMENT_TYPE_DP_EXTENDED_ESSAY = "DP_EE";
export const ELEMENT_TYPE_DP_CAS = "DP_CAS";
export const ELEMENT_TYPE_DP_AIM = "DP_AIM";
export const ELEMENT_TYPE_CP_SL = "CP_SL";
export const ELEMENT_TYPE_CP_CE = "CP_CE";
export const ELEMENT_TYPE_CE_LEARNING_OUTCOMES = "ACHIEVED_PLANNER_ELEMENT_MAP";
export const ELEMENT_TYPE_CP_RP = "CP_RP";
export const ELEMENT_TYPE_MYP_COMMUNITY_PROJECT = "COMMUNITY_PROJECT";
export const ELEMENT_TYPE_MYP_PERSONAL_PROJECT = "PERSONAL_PROJECT";

export const ELEMENT_TYPE_MYP_ACHIEVEMENT_LEVEL = "MYP_ACHIEVEMENT_LEVEL";

export const ELEMENT_SUB_TYPE_SUBJECT_CRITERIA = "SUBJECT_CRITERIA";
export const ELEMENT_SUB_TYPE_INTERDISCIPLINARY_CRITERIA =
  "INTERDISCIPLINARY_CRITERIA";

export const ELEMENT_TYPE_ALL_ASSESSMENTS = "ALL_ASSESSMENTS";
export const ELEMENT_TYPE_GRADING_PERIOD_OVERVIEW = "GRADING_PERIOD_OVERVIEW";
export const PLANNER_ELEMENT_SUMMARY = "PLANNER_ELEMENT_SUMMARY";
export const ELEMENT_TYPE_IB_GRADE_ASSESSMENTS = "IB_GRADE_ASSESSMENTS";
export const ELEMENT_TYPE_CATEGORY_WISE_ASSESSMENTS =
  "CATEGORY_WISE_ASSESSMENTS";
export const ELEMENT_TYPE_EXTERNAL_ASSESSMENTS = "EXTERNAL_ASSESSMENTS";

//Template Field
export const TEMPLATE_FIELD_SERVICE_ACTION_OUTCOMES_MYP =
  "serviceActionOutcomeMYP";
export const TEMPLATE_FIELD_ATLS_MYP = "atlsMYP";
export const TEMPLATE_FIELD_OBJECTIVES_MYP = "objectivesMYP";
export const TEMPLATE_FIELD_RELATED_CONCEPTS_MYP = "relatedConceptsMYP";
export const TEMPLATE_FIELD_LEARNING_STANDARDS_MYP = "learningStandardMYP";

export const TEMPLATE_FIELD_DISCIPLINARY_CONTENT = "disciplinaryContent";
export const TEMPLATE_FIELD_DISCIPLINARY_LE_QUESTION = "disciplinaryLeQuestion";
export const TEMPLATE_FIELD_DISCIPLINARY_OBJECTIVES_MYP =
  "disciplinaryObjectivesMYP";
export const TEMPLATE_FIELD_DISCIPLINARY_LEARNING_STANDARDS_MYP =
  "disciplinaryLearningStandardMYP";
export const TEMPLATE_FIELD_DISCIPLINARY_RELATED_CONCEPTS_MYP =
  "disciplinaryRelatedConceptsMYP";

export const TEMPLATE_FIELD_LE_QUESTION = "leQuestion";
export const TEMPLATE_FIELD_CONTENT = "content";

export const TEMPLATE_FIELD_CAS_LEARNING_OUTCOMES_DP = "casLearningOutcomes";
export const TEMPLATE_FIELD_SL_LEARNING_OUTCOMES_DP = "slLearningOutcomes";
export const TEMPLATE_FIELD_CE_LEARNING_OUTCOMES_DP = "ceLearningOutcomes";
export const TEMPLATE_FIELD_CE_PROCESS_STAGES = "ceStages";
export const TEMPLATE_FIELD_CE_PROCESS_DIMENSIONS = "ceDimensions";
export const TEMPLATE_FIELD_CE_PROCESS_PRINCIPLES = "cePrinciples";

export const TEMPLATE_FIELD_INQUIRY_QUESTIONS = "inquiryQuestions";
export const TEMPLATE_FIELD_LINES_OF_INQUIRY = "lois";
export const TEMPLATE_FIELD_INQUIRY_QUESTIONS_V2 = "inquiryQuestionsV2";
export const TEMPLATE_FIELD_UN_GOALS = "unGoals";
export const TEMPLATE_FIELD_UN_GOALS_ASSESSMENT = "unGoalsAssessment";

// Planner element type
export const PLANNER_ELEMENT_NESTED_CHECKLIST = "NESTED_CHECKLIST";

export const EVIDENCE_TYPE_POST = "POST";
export const EVIDENCE_TYPE_ASSESSMENT = "ASSESSMENT";
export const EVIDENCE_TYPE_UNIT = "UNIT_PLAN";
export const EVIDENCE_TYPE_PROGRESS_REPORT = "STUDENT_PROGRESS_REPORT";
export const EVIDENCE_TYPE_ASSIGNMENT = "ASSIGNMENT";

export const ASSIGNMENT_TYPE_QUICK_TASK = "qt";
export const ASSIGNMENT_TYPE_LE = "le";
export const ASSIGNMENT_TYPE_SUMMATIVE = "smt";
export const ASSIGNMENT_TYPE_FORMATIVE = "fmt";
export const ASSIGNMENT_TYPE_PERFORMANCE_TASK = "pt";
export const ASSIGNMENT_TYPE_CGC_ASSESSMENT = "asmt";
export const ASSIGNMENT_TYPE_PRE_ASSESSMENT = "pri";
export const ASSIGNMENT_TYPE_SUPPLEMENTARY = "se";
export const ASSIGNMENT_TYPE_ASSIGNMENT_RESOURCE = "ASSIGNMENT_RESOURCE";
export const ASSIGNMENT_TYPE_WORKSHEET = "worksheet";
export const ASSESSMENT_TYPE_AI_TUTOR = "ai_tutor";
export const ASSESSMENT_TYPE_WORKSHEET = "worksheet";

//task types

export const TASK_TYPE_QUICK_TASK = "QUICK_TASK";
export const TASK_TYPE_LEARNING_ENGAGEMENT = "LEARNING_ENGAGEMENT";
export const TASK_TYPE_ASSESSMENT = "ASSESSMENT";
export const TASK_TYPE_WORKSHEET = "WORKSHEET";
export const TASK_TYPE_AI_TUTOR = "AI_TUTOR";

//check box state
export const CHECKED = "checked";
export const UNCHECKED = "unchecked";
export const INTERMEDIATE = "intermediate";
export const MYP_SUBJECT_SPECIFIC = "ibMYPSubjectSpecific";
export const ELEMENT_TYPE_LEARNER_PROFILE = "LEARNER_PROFILE";
export const ELEMENT_TYPE_CONCEPT = "CONCEPT";
export const ELEMENT_TYPE_ATL = "ATL";
export const ELEMENT_TYPE_PYP_BENCHMARK = "BENCHMARK";
export const SUBJECT = "SUBJECT";
export const AUTOMATIC = "AUTOMATIC";
export const MANUAL = "MANUAL";
export const STUDENT_REFLECTION_AUTHOR_STUDENT = "STUDENT";
export const STUDENT_REFLECTION_AUTHOR_TEACHER = "TEACHER";

//constants for progress report configuration (used for advisorComment and attendance)
export const SEPARATE_PAGE = "separatePage";
export const PROGRESS_SUMMARY_PAGE = "progressSummaryPage";
export const PROGRESS_SUMMARY = "PROGRESS_SUMMARY";
export const ATTENDANCE_SEPARATE_PAGE = "ATTENDANCE_SEPARATE_PAGE";
export const ATTENDANCE_PROGRESS_SUMMARY_PAGE =
  "ATTENDANCE_PROGRESS_SUMMARY_PAGE";
export const ATTENDANCE_SUBJECT_REPORT_PAGE = "ATTENDANCE_SUBJECT_REPORT_PAGE";
export const ATTENDANCE_COURSE_REPORT_PAGE = "ATTENDANCE_COURSE_REPORT_PAGE";
export const SEPARATELY_FOR_EACH_TERM = "separatelyForEachTerm";
export const TERM_WISE = "termWise";
export const ON_THE_BASIS_DATE_RANGE = "onTheBasisDateRange";

export const OVERALL_PRESENCE = "OVERALL_PRESENCE";

export const ATTENDANCE_SETUP = "ATTENDANCE_SETUP";
export const ATTENDANCE_CODES = "attendanceCodes";
export const ATTENDANCE_CATEGORIES = "attendanceCategories";

export const ATTENDANCE_CATEGORY = "ATTENDANCE_CATEGORY";

export const ATTENDANCE_SEPARATE_PAGE_CATEGORY_BREAKDOWN =
  "ATTENDANCE_SEPARATE_PAGE_CATEGORY_BREAKDOWN";
export const ATTENDANCE_PROGRESS_SUMMARY_PAGE_CATEGORY_BREAKDOWN =
  "ATTENDANCE_PROGRESS_SUMMARY_PAGE_CATEGORY_BREAKDOWN";
export const ATTENDANCE_SUBJECT_REPORT_PAGE_CATEGORY_BREAKDOWN =
  "ATTENDANCE_SUBJECT_REPORT_PAGE_CATEGORY_BREAKDOWN";
export const ATTENDANCE_COURSE_REPORT_PAGE_CATEGORY_BREAKDOWN =
  "ATTENDANCE_COURSE_REPORT_PAGE_CATEGORY_BREAKDOWN";
export const ATTENDANCE_SEPARATE_PAGE_CATEGORY_BREAKDOWN_V2 =
  "ATTENDANCE_SEPARATE_PAGE_CATEGORY_BREAKDOWN_V2";
export const ATTENDANCE_PROGRESS_SUMMARY_PAGE_CATEGORY_BREAKDOWN_V2 =
  "ATTENDANCE_PROGRESS_SUMMARY_PAGE_CATEGORY_BREAKDOWN_V2";
export const ATTENDANCE_SUBJECT_REPORT_PAGE_CATEGORY_BREAKDOWN_V2 =
  "ATTENDANCE_SUBJECT_REPORT_PAGE_CATEGORY_BREAKDOWN_V2";
export const ATTENDANCE_COURSE_REPORT_PAGE_CATEGORY_BREAKDOWN_V2 =
  "ATTENDANCE_COURSE_REPORT_PAGE_CATEGORY_BREAKDOWN_V2";

//Attachment type constants
export const ATTACHMENT_TYPE_LINK = "LINK";

export const ATTACHMENT_TYPE_ZIP = "ZIP";
export const ATTACHMENT_TYPE_EXCEL = "EXCEL";

export const SEPARATE = "separate";
export const CUMULATIVE = "cumulative";
export const SUBJECT_REPORT_PAGE = "subjectReportPage";
export const PERCENTAGE = "percentage";
export const NUMBER = "number";

//subscription plan types
export const PLAN_TYPE_360 = "PLAN_360";
export const PLAN_TYPE_360_PILOT = "PLAN_360_PILOT";
export const PLAN_TYPE_DEMO = "PLAN_DEMO";
export const PLAN_TYPE_FREE = "PLAN_FREE";
export const PLAN_TYPE_PRO = "PLAN_PRO";
export const PLAN_TYPE_PRO_PILOT = "PLAN_PRO_PILOT";
export const PLAN_TYPE_ULTIMATE = "PLAN_ULTIMATE";
export const PLAN_TYPE_ULTIMATE_PILOT = "PLAN_ULTIMATE_PILOT";

//curriculum plan types
export const CURRICULUM_PLAN_TYPE_FREEMIUM = "FREEMIUM";
export const CURRICULUM_PLAN_TYPE_PRO_AI = "PRO_AI";
export const CURRICULUM_PLAN_TYPE_ESSENTIALS = "ESSENTIALS";
export const CURRICULUM_PLAN_TYPE_ULTIMATE = "ULTIMATE";
export const CURRICULUM_PLAN_TYPE_PRO = "PRO";
export const CURRICULUM_PLAN_NA = "NA";

//DP grade uids

export const DP_1 = "DP 1";
export const DP_2 = "DP 2";
export const SCORE = "SCORE";
export const ASSESSMENT_TOOL = "assessmentTool";
export const LEARNING_GOALS = "learningGoals";

//Unit types

export const UNIT_TYPE_DP = "ibDPSubjectSpecific";
export const UNIT_TYPE = "UNIT_TYPE";

//Screen modes

export const VIEW_MODE = "VIEW";
export const EDIT_MODE = "EDIT";

//Subject Types

export const SUBJECT_TYPE_GENERIC = "GENERIC";
export const SUBJECT_TYPE_TOK = "TOK";
export const SUBJECT_TYPE_OTHERS = "OTHERS";
export const SUBJECT_TYPE_EE = "EE";
export const SUBJECT_TYPE_CAS = "CAS";
export const SUBJECT_TYPE_RP = "RP";
export const SUBJECT_TYPE_LD = "LD";
export const SUBJECT_TYPE_PPS = "PPS";
export const SUBJECT_TYPE_SLR = "SLR";
export const SUBJECT_TYPE_CE = "CE";

//Generic Constants

export const CACHE_AND_NETWORK = "cache-and-network";
export const CREATE = "CREATE";
export const EDIT = "EDIT";
export const DELETE = "DELETE";
export const DUPLICATE = "DUPLICATE";
export const STAFF = "staff";
export const ADVISOR = "advisor";
export const SUPERVISOR = "supervisor";
export const SUPERVISORS = "supervisors";
export const PARENT = "parent";
export const STUDENT = "student";
export const ADMIN = "admin";
export const STAFF_USER = "STAFF";
export const STUDENT_USER = "STUDENT";
export const TEACHER = "TEACHER";
export const TEACHER_USER = "teacher";
export const ROLE_VISITOR = "visitor";
export const SELF = "self";
export const FAMILY_MEMBER = "FAMILY_MEMBER";
export const FIRST_NAME = "FIRST_NAME";
export const MIDDLE_NAME = "MIDDLE_NAME";
export const LAST_NAME = "LAST_NAME";
export const PREFIX = "PREFIX";

export const FULL_NAME = "FULL_NAME";
export const DEFAULT_NAME_ORDER_PREFERENCE = [FIRST_NAME, LAST_NAME];
export const NAME_MAPPING = {
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
  MIDDLE_NAME: "middleName",
  SUFFIX: "suffix",
  PRONOUNS: "pronouns",
  PREFERRED_NAME: "preferredName",
  PREFIX: "prefix",
};
export const ASC = "ASC";
export const DESC = "DESC";
export const STUDENT_FIRST_NAME = "STUDENT_FIRST_NAME";
export const STUDENT_MIDDLE_NAME = "STUDENT_MIDDLE_NAME";
export const STUDENT_LAST_NAME = "STUDENT_LAST_NAME";
export const STUDENT_FULL_NAME = "STUDENT_FULL_NAME";
export const PENDING = "PENDING";
export const COMPLETED = "COMPLETED";
export const IN_PROGRESS = "IN_PROGRESS";
export const STAFF_FIRST_NAME = "STAFF_FIRST_NAME";
export const STAFF_MIDDLE_NAME = "STAFF_MIDDLE_NAME";
export const STAFF_LAST_NAME = "STAFF_LAST_NAME";
export const STAFF_FULL_NAME = "STAFF_FULL_NAME";
export const FAILED = "FAILED";

export const NAME = "NAME";
export const NETWORK_ONLY = "network-only";
export const NOTIFICATIONS = "NOTIFICATIONS";
export const HELP_CENTER = "HELP_CENTER";
export const MESSAGING = "MESSAGING";
export const ASSESSMENT_CATEGORIES = "ASSESSMENT_CATEGORIES";
export const FINAL_SCORE = "FINAL_SCORE";
export const PRIMARY_FINAL_GRADE = "PRIMARY_FINAL_GRADE";
export const PUBLISHED = "PUBLISHED";
export const ARCHIVED = "ARCHIVED";
export const UNITS_ASSOCIATED = "units_associated";
export const ROOT = "root";
export const ACTIVE = "ACTIVE";
export const VISITOR = "VISITOR";
export const MIXED = "MIXED";
export const NO_ACCESS = "NO_ACCESS";
export const ACCESS = "ACCESS";
export const STUDENT_SIGN_IN_CODE = "STUDENT_SIGN_IN_CODE";
export const FAMILY_INVITE_CODE = "FAMILY_INVITE_CODE";
export const LOGOUT_STUDENTS_IN_BULK = "LOGOUT_STUDENTS_IN_BULK";
export const LOGOUT_STUDENT = "LOGOUT_STUDENT";
export const UNAUTHORIZED_ERROR_MESSAGE_STUDENT_ENTITY =
  "JWT_OID_MISMATCH(TRYING TO ACCESS DELETED/UNAVAILABLE STUDENT)";
export const REMOVE = "REMOVE";
export const RETAIN = "RETAIN";
export const CATEGORY_PLACEHOLDER = "CATEGORY_PLACEHOLDER";
export const GRADE = "GRADE";
export const DEFAULT = "DEFAULT";
export const CATEGORY_SCORE = "CATEGORY_SCORE";
export const CATEGORY_GRADE = "CATEGORY_GRADE";
export const STUDENTS = "STUDENTS";
export const YEAR_GROUP = "YEAR_GROUP";
export const CLASSES = "CLASSES";
export const COURSE = "COURSE";
export const CLASS = "CLASS";
export const LEARNING_COURSE = "LEARNING_COURSE";

//constants related to transcripts
export const SCHOOL_NAME = "SCHOOL_NAME";
export const SCHOOL_LOGO = "SCHOOL_LOGO";
export const TRANSCRIPT_TITLE = "TRANSCRIPT_TITLE";
export const ISSUE_DATE = "ISSUE_DATE";
export const SCHOOL_LOGO_CONTAINER = "SCHOOL_LOGO_CONTAINER";
export const IB_LOGO_IMAGE = "IB_LOGO_IMAGE";
export const TRANSCRIPT_HEADER = "TRANSCRIPT_HEADER";
export const NONE = "NONE";
export const SUM = "SUM";
export const AVERAGE = "AVERAGE";

//Curriculum program node types
export const DP_SUBJECT_SPECIFIC = "ibDPSubjectSpecific";

// Project Constants
export const PROJECT_TYPE_PERSONAL = "PERSONAL";
export const PROJECT_TYPE_COMMUNITY = "COMMUNITY";
export const PROJECT_TYPE_SERVICE_AS_ACTION = "SERVICE_AS_ACTION";
export const PROJECT_TYPE_DP_TOK_EXHIBITION = "DP_TOK_EXHIBITION";
export const PROJECT_TYPE_DP_TOK_ESSAY = "DP_TOK_ESSAY";
export const PROJECT_TYPE_DP_EXTENDED_ESSAY = "DP_EE";
export const PROJECT_TYPE_DP_CAS = "DP_CAS";
export const PROJECT_TYPE_CP_REFLECTIVE_PROJECT = "CP_REFLECTIVE_PROJECT";
export const PROJECT_TYPE_CP_SERVICE_LEARNING = "CP_SERVICE_LEARNING";
export const PROJECT_TYPE_CP_COMMUNITY_ENGAGEMENT = "COMMUNITY_ENGAGEMENT";
export const PROJECT_SUBTYPE_INTERNAL_ASSESSMENT = "INTERNAL_ASSESSMENT";
export const PROJECT_SUBTYPE_EXTERNAL_ASSESSMENT = "EXTERNAL_ASSESSMENT";
export const PROJECT_SUBTYPE_SUBJECT_GROUP_PROJECT = "SUBJECT_GROUP_PROJECT";
export const PROJECT_SUBTYPE_CORE = "CORE";

export const EQUAL_WEIGHTS = "EQUAL_WEIGHTS";
export const WEIGHTS_PROPORTIONAL = "WEIGHTS_PROPORTIONAL";
export const CUSTOM_WEIGHTS = "CUSTOM_WEIGHTS";
export const ABSOLUTE_WEIGHTS = "ABSOLUTE_WEIGHTS";

export const GRADE_CALCULATION_METHODS = [
  EQUAL_WEIGHTS,
  WEIGHTS_PROPORTIONAL,
  CUSTOM_WEIGHTS,
];

// Assessment tools

export const RUBRIC = "RUBRIC";
export const MYP_OBJECTIVE_RUBRIC = "MYP_OBJECTIVE_RUBRIC";
export const MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC =
  "MYP_INTERDISCIPLINARY_CRITERIA_RUBRIC";
export const SINGLE_POINT_RUBRIC = "SINGLE_POINT_RUBRIC";
export const CHECKLIST = "CHECKLIST";

export const DP_ASSESSMENT_RUBRIC = "DP_ASSESSMENT_RUBRIC";
export const COMMENT = "COMMENT";
export const ASSESSMENT_GRADE_BOUNDARY = "ASSESSMENT_GRADE_BOUNDARY";
export const GRADE_SCALE_TOOL = "GRADE_SCALE_TOOL";
export const ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY =
  "ASSESSMENT_AUTO_EVALUATE_CUSTOM_GRADE_BOUNDARY";
export const ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY =
  "ASSESSMENT_AUTO_EVALUATE_CATEGORY_GRADE_BOUNDARY";
export const ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY =
  "ASSESSMENT_AUTO_EVALUATE_TERM_GRADE_BOUNDARY";
export const ANALYSIS = "ANALYSIS";
export const SCORE_BASED_RUBRIC = "SCORE_BASED_RUBRIC";
export const STANDARD_BASED_RUBRIC = "STANDARD_BASED_RUBRIC";

export const EXPLANATORY = "EXPLANATORY";
export const GRADE_BASED = "GRADE_BASED";
export const FIXED = "FIXED";
export const FLEXIBLE = "FLEXIBLE";

export const ANALYSING = "ANALYSING";

export const UNGRADED = "UNGRADED";

// Navigation route source
export const STUDENT_PROFILE = "STUDENT_PROFILE";

//Attachment Locked State
export const ENTITY_LOCKED_STATE = "LOCKED";
export const ENTITY_UNLOCKED_STATE = "UNLOCKED";
export const ENTITY_TO_BE_LOCKED_STATE = "TO_BE_LOCKED";

export const ENTITY_LOCKING_MINUTES = 15;

export const ENTITY_TYPE_ATTACHMENT = "ATTACHMENT";
export const ENTITY_TYPE_PROJECT_ACADEMIC_HONESTY = "PROJECT_ACADEMIC_HONESTY";
export const ENTITY_TYPE_REMARK = "REMARK";

// Access levels

// Learning courses columns configuration
export const LEARNING_COURSES_COLUMNS = "LearningCourseTableColumns";

// assessment types

export const ASSESSMENT = "ASSESSMENT";
export const LEARNING_ENGAGEMENT = "LEARNING_ENGAGEMENT";
export const WORKSHEET = "WORKSHEET";
export const AI_TUTOR = "AI_TUTOR";

// i18n Languages
export const I18N_LANGUAGE_SPANISH = "es";
export const I18N_LANGUAGE_FRENCH = "fr";
export const I18N_LANGUAGE_CHINESE = "zh";

export const ASSESSMENTS_AND_LEARNING_GOALS = "ASSESSMENTS_AND_LEARNING_GOALS";
// DP Constants
export const DP_MAX_GRADE = 7;

//DP Global Grades
export const GRADE_11 = "Grade 11";
export const GRADE_12 = "Grade 12";

// SnP evidence status
export const SUGGESTED_EVIDENCE_STATUS = "SUGGESTED";
export const APPROVED_EVIDENCE_STATUS = "APPROVED";

export const ALL_LEARNING_GOALS = "ALL_LEARNING_GOALS";

// Academic setup type
export const COURSE_BASED_GRADING = "COURSE_BASED_GRADING";
export const SUBJECT_BASED_GRADING = "SUBJECT_BASED_GRADING";
export const OLD_SUBJECT_BASED_GRADING = "OLD_SUBJECT_BASED_GRADING";

// Family invite statuses
export const FAMILY_INVITE_STATUS_INVITED = "INVITED";

export const SUBJECT_GROUP_OTHERS = "OTHERS";

export const GRADE_BOUNDARY_CREATION_EVENT = "GRADE_BOUNDARY_CREATION_EVENT";
export const CUSTOM_TERM_GRADE_BOUNDARY = "CUSTOM_TERM_GRADE_BOUNDARY";
export const IB_DEFINED_TERM_GRADE_BOUNDARY = "IB_DEFINED_TERM_GRADE_BOUNDARY";
export const BULK_DUPLICATE_TO_OTHER_SUBJECTS =
  "BULK_DUPLICATE_TO_OTHER_SUBJECTS";
export const BULK_IMPORT_FROM_OTHER_TERM = "BULK_IMPORT_FROM_OTHER_TERM";

export const GRADING_PERIOD_CUMULATIVE = "CUMULATIVE";
export const GRADING_SETUP = "GRADING_SETUP";
export const OVERALL_SETUP = "OVERALL_SETUP";
export const NOMENCLATURE_SETUP = "NOMENCLATURE_SETUP";
export const OVERALL_GRADING_SETUP = "OVERALL_GRADING_SETUP";
export const OVERALL_GRADE_SETUP = "OVERALL_GRADE_SETUP";
export const ASSESSMENT_CATEGORY_SETUP = "ASSESSMENT_CATEGORY_SETUP";
export const CUMULATIVE_SCORE_SETUP = "CUMULATIVE_SCORE_SETUP";
export const GRADE_BOUNDARY_SETUP = "GRADE_BOUNDARY_SETUP";

export const LOCAL_GRADE_SETUP = "LOCAL_GRADE_SETUP";
export const GRADE_SCALE_SETUP = "GRADE_SCALE_SETUP";
export const AGGREGATE_SETUP = "AGGREGATE_SETUP";
export const ASSESSMENT_WEIGHT_SETUP = "ASSESSMENT_WEIGHT_SETUP";
export const ASSESSMENT_SETTINGS_EVALUATION_CRITERIA =
  "ASSESSMENT_SETTINGS_EVALUATION_CRITERIA";
export const CREATE_EVALUATION_CRITERIA = "CREATE_EVALUATION_CRITERIA";
export const MAP_EVALUATION_CRITERIA = "MAP_EVALUATION_CRITERIA";
export const EVALUATION_CRITERIA_SETTINGS = "EVALUATION_CRITERIA_SETTINGS";
export const GPA_AND_CREDITS = "GPA_AND_CREDITS";
export const GPA_SETUP = "GPA_SETUP";
export const CREDITS_SETUP = "CREDITS_SETUP";
export const SUMMARY_EMAIL_TRIGGER_TIME = "SUMMARY_EMAIL_TRIGGER_TIME";
export const SUMMARY_EMAIL_TRIGGER_DAY = "SUMMARY_EMAIL_TRIGGER_DAY";

export const WHOLE_NUMBER = "WHOLE_NUMBER";
export const PERCENTAGE_UPPERCASE = "PERCENTAGE";
export const DECIMAL = "DECIMAL";
export const WEIGHT = "WEIGHT";

export const WEIGHTED = "WEIGHTED";
export const UNWEIGHTED = "UNWEIGHTED";
export const MYP_CRITERIA = "MYP_CRITERIA";

export const LOCKED = "LOCKED";

export const UNLOCKED = "UNLOCKED";

// Identity configuration type constants
export const ACCESS_MANAGER = "ACCESS_MANAGER";
export const ACCESS_MANAGER_REQUEST = "ACCESS_MANAGER_REQUEST";
export const MANAGE_USERS = "MANAGE_USERS";
export const ORGANIZATIONS = "ORGANIZATIONS";
export const VIEW_CONFIGURATION_TOOL = "VIEW_CONFIGURATION_TOOL";
export const WRITE_CONFIGURATION_TOOL = "WRITE_CONFIGURATION_TOOL";
export const WRITE_VALUE_CONFIGURATION_TOOL = "WRITE_VALUE_CONFIGURATION_TOOL";
export const TEMPLATE_EDITOR = "TEMPLATE_EDITOR";
export const INTERNAL_TOOLS = "INTERNAL_TOOLS";
export const ACTIVATE_SCHOOLS = "ACTIVATE_SCHOOLS";
export const CREATE_ORGANIZATION = "CREATE_ORGANIZATION";
export const PLATFORM_ACCESS_MANAGER = "PLATFORM_ACCESS_MANAGER";
export const TOOLS = "TOOLS";
export const INTERNAL_PORTAL = "INTERNAL_PORTAL";
export const INTERNAL_PORTAL_ACCESS = "INTERNAL_PORTAL_ACCESS";
export const VIEW_CONFIGURATIONS = "VIEW_CONFIGURATIONS";
export const DELETE_ORGANIZATION = "DELETE_ORGANIZATION";
export const GRAPHQL_PLAYGROUND = "GRAPHQL_PLAYGROUND";
export const SWITCH_SCHOOL_USERNAME = "SWITCH_SCHOOL_USERNAME";
export const ALLOW_ELASTICACHE_MANAGEMENT = "ALLOW_ELASTICACHE_MANAGEMENT";
export const ELASTICACHE_FLUSHDB_ALLOWED_IDENTITIES =
  "ELASTICACHE_FLUSHDB_ALLOWED_IDENTITIES";
export const ALLOW_ELASTICACHE_AUDIT_LOG_VIEWING =
  "ALLOW_ELASTICACHE_AUDIT_LOG_VIEWING";

// Visitor module name constants

export const MAY = "MAY";
export const NOVEMBER = "NOVEMBER";

export const GRADE_BOUNDARY = "GRADE_BOUNDARY";
export const FINAL_GRADE = "FINAL_GRADE";
export const LOCAL_GRADE = "LOCAL_GRADE";
export const CATEGORY_TOTAL = "CATEGORY_TOTAL";
export const IB_DEFINED = "IB_DEFINED";
export const MYP_CRITERIA_FINAL_SCORE = "MYP_CRITERIA_FINAL_SCORE";
export const CUSTOM = "CUSTOM";
export const GRADE_SCALE = "GRADE_SCALE";
export const CATEGORY_GRADE_SCALE = "CATEGORY_GRADE_SCALE";

// Subject level tags colors
export const SUBJECT_LEVEL_TAGS_COLORS = [
  "violet",
  "blue",
  "yellow",
  "pink",
  "teal",
  "purple",
];

// AI Constants
export const BLOCK_ACTIONS = "BLOCK_ACTIONS";

export const WRITING = "WRITING";
export const STREAMING = "STREAMING";
export const THINKING = "THINKING";
export const LOADING = "LOADING";
export const BROWSING_THE_INTERNET = "BROWSING_THE_INTERNET";
export const ADDING_TO_UNIT = "ADDING_TO_UNIT";
export const GATHERING_CURRICULUM_INFORMATION =
  "GATHERING_CURRICULUM_INFORMATION";
export const MARKDOWN = "MARKDOWN";
export const FETCHING_TRANSCRIPT = "FETCHING_TRANSCRIPT";
export const CREATING_BANNER = "CREATING_BANNER";
export const FETCHING_RECIPIENTS = "FETCHING_RECIPIENTS";
export const SELECTING_RECIPIENTS = "SELECTING_RECIPIENTS";
export const CREATING_BANNER_WITHOUT_TOKEN = "CREATING_BANNER_WITHOUT_TOKEN";

export const RTE = "RTE";
export const UNIT_FLOW = "UNIT_FLOW";
export const PROGRESS_REPORT = "PROGRESS_REPORT";
export const GENERATING_EVALUATION = "GENERATING_EVALUATION";
export const GENERATING = "GENERATING";
export const TOOL_INDICATION = "TOOL_INDICATION";
export const ANNOUNCEMENT = "ANNOUNCEMENT";
export const ANNOUNCEMENT_AI = "ANNOUNCEMENT_AI";
export const BEHAVIOR = "BEHAVIOR";
export const SEARCHING = "SEARCHING";
export const ADDING_TO_UNIT_FLOW = "ADDING_TO_UNIT_FLOW";

// admin portal route
export const ALL_STUDENTS = "ALL_STUDENTS";

//PSOW Constants
export const DP_PRACTICAL_ACTIVITY = "dp_pa";
export const DP_EXPERIMENTAL_PROGRAMME = "dp_ep";

// common types
export const CORE_AND_OTHER_TYPES = ["CORE", "OTHERS", "CP_CORE"];
export const CORE_TYPES = ["CORE", "CP_CORE"];
export const CORE_TOK_AND_OTHER_TYPES = ["CORE", "OTHERS", "CP_CORE", "TOK"];
export const CP_CORE_TYPES = ["CP_CORE"];

// platform Constants

//Multimedia Constants
export const MICROSOFT_SERVICE_TYPE = "MICROSOFT";
export const GOOGLE_SERVICE_TYPE = "GOOGLE";
export const STUDENT_TEMPLATE_OPTION_NONE = "None";

export const LEX_PILOT_CODE_VERIFIER_KEY = "lex_pilot_code_verifier";
export const LEX_CODE_VERIFIER_KEY = "lex_code_verifier";

export const TODDLE_LIBRARY = "TODDLE_LIBRARY";
export const SCHOOL_LIBRARY = "SCHOOL_LIBRARY";

// Assignment Constants
export const STUDENT_ASSIGNMENT = "STUDENT_ASSIGNMENT";

export const PLANNER = "PLANNER";
export const CREATE_LE = "CREATE_LE";
export const CREATE_FA = "CREATE_FA";
export const CREATE_SA = "CREATE_SA";
export const CREATE_ASSESSMENT = "CREATE_ASSESSMENT";
export const CREATE_WORKSHEET = "CREATE_WORKSHEET";
export const CREATE_WORKSHEET_FROM_TODDLE_LIBRARY =
  "CREATE_WORKSHEET_FROM_TODDLE_LIBRARY";
export const CREATE_AI_TUTOR = "CREATE_AI_TUTOR";

export const IMPORT_IN_CLASS = "IMPORT_IN_CLASS";
export const ASSIGN_TO_CLASS = "ASSIGN_TO_CLASS";
export const CREATE_QUICK_TASK = "CREATE_QUICK_TASK";

export const UNIT_SELECTION = "UNIT_SELECTION";
export const QUESTION_CREATION = "QUESTION_CREATION";

export const ASSESSMENT_DETAILS = "ASSESSMENT_DETAILS";
export const SETTINGS = "SETTINGS";

export const IMPORT_LE_FROM_COMMUNITY = "IMPORT_LE_FROM_COMMUNITY";
export const IMPORT_LE = "IMPORT_LE";
export const IMPORT_LE_FROM_LE_LIBRARY = "IMPORT_LE_FROM_LE_LIBRARY";
export const IMPORT_LE_FROM_TODDLE_LIBRARY = "IMPORT_LE_FROM_TODDLE_LIBRARY";
export const IMPORT_TODDLE_LIBRARY_WORKSHEET_IN_CLASS =
  "IMPORT_TODDLE_LIBRARY_WORKSHEET_IN_CLASS";
export const UNIT = "UNIT";

export const LE_CREATE_UNIT_SELECTION = "LE_CREATE_UNIT_SELECTION";
export const SMT_CREATE_UNIT_SELECTION = "SMT_CREATE_UNIT_SELECTION";
export const FMT_CREATE_UNIT_SELECTION = "FMT_CREATE_UNIT_SELECTION";
export const WORKSHEET_UNIT_SELECTION = "WORKSHEET_UNIT_SELECTION";
export const ASSESSMENT_CREATE_UNIT_SELECTION =
  "ASSESSMENT_CREATE_UNIT_SELECTION";

export const LE_SELECTION = "LE_SELECTION";
export const LE_LIBRARY_LE_SELECTION = "LE_LIBRARY_LE_SELECTION";
export const COMMUNITY_LE_SELECTION = "COMMUNITY_LE_SELECTION";

export const RESOURCE_SELECTION = "RESOURCE_SELECTION";
export const UNIT_FROM_GRADE_SELECTION = "UNIT_FROM_GRADE_SELECTION";
export const DISCUSSION_CREATION = "DISCUSSION_CREATION";
export const LEARNING_COURSE_SELECTION = "LEARNING_COURSE_SELECTION";

export const SELECT_POST = "SELECT_POST";
export const TODDLE_LIBRARY_WORKSHEET_SELECTION =
  "TODDLE_LIBRARY_WORKSHEET_SELECTION";

export const SMT_CREATION = "SMT_CREATION";
export const FMT_CREATION = "FMT_CREATION";
export const LE_CREATION = "LE_CREATION";
export const QT_CREATION = "QT_CREATION";
export const ASSESSMENT_CREATION = "ASSESSMENT_CREATION";
export const AI_TUTOR_CREATION = "AI_TUTOR_CREATION";

export const WORKSHEET_QUESTION_CREATION = "WORKSHEET_QUESTION_CREATION";
export const WORKSHEET_AI_ASSESSMENT_TOOLS = "WORKSHEET_AI_ASSESSMENT_TOOLS";

export const CLASS_SELECTION = "CLASS_SELECTION";

export const HOMEROOM_PERIODS = "homeroomPeriods";
export const ALL_PERIODS = "allPeriods";

// project deadline notification type
export const PROJECT_DEADLINE_REMINDER = "PROJECT_DEADLINE_REMINDER";
export const PROJECT_DEADLINE_REMINDER_V2 = "PROJECT_DEADLINE_REMINDER_V2";

export const COMMUNITY_ORG_ID = "-7";

export const CLASS_STREAM = "CLASS_STREAM";
export const CLASS_FLOW = "CLASS_FLOW";

export const LONG_RUNNING_EDUCATOR_PUBLISH_TYPE =
  "LONG_RUNNING_TASK_TYPE_PUBLISH_EDUCATOR_CENTRE_RESOURCES";

// user access blocked msg constant
export const USER_ACCESS_BLOCKED_NETWORK_ERROR = "User access has been blocked";

// school setup constants
export const BULK_BLOCK_STUDENTS = "BULK_BLOCK_STUDENTS";
export const BULK_UNBLOCK_STUDENTS = "BULK_UNBLOCK_STUDENTS";

export const HOMEROOM_ADVISOR = "HOMEROOM_ADVISOR";

export const STUDENT_PROFILE_CUSTOM_FIELDS_CONFIG =
  "STUDENT_PROFILE_CUSTOM_FIELDS_CONFIG";

//constants for Progress Report
export const MYP_CRITERIA_TOTAL_TYPE_ALL_CRITERIA = "ALL_CRITERIA_RATED";

export const PLANNER_ELEMENT_TYPE_PYP_ATL = "atl";
export const PLANNER_ELEMENT_TYPE_MYP_ATL = "mypAtl";
export const PLANNER_ELEMENT_TYPE_DP_ATL = "dpAtl";
export const PLANNER_ELEMENT_TYPE_UBD_ATL = "ubdAtl";

// assignment settings constants
export const OPENS_ON = "OPENS_ON";
export const DUE_ON = "DUE_ON";
export const CLOSES_ON = "CLOSES_ON";
export const VISIBILITY = "VISIBILITY";
export const TAGS = "TAGS";
export const SECURITY_MODE = "SECURITY_MODE";
export const DURATION = "DURATION";
export const VISIBLE = "VISIBLE";
export const TO_BE_VISIBLE = "TO_BE_VISIBLE";
export const PRIVATE = "PRIVATE";
export const CONFIGURE_ASSIGN_SETTINGS_SEEN = "CONFIGURE_ASSIGN_SETTINGS_SEEN";

// shortcut submit button prop
export const SHIFT_ENTER_SUBMIT_SHORTCUT = {
  code: "Enter",
  shiftKey: true,
};

// shortcut for create button prop
export const CREATE_BUTTON_SHORTCUT = {
  code: "KeyC",
};

export const IS_TODDLE_INITIATED = "is_toddle_initiated";

export const SCHOOL_INFORMATION = "SCHOOL_INFORMATION";
export const HOME_PAGE = "HOME_PAGE";

export const FIELD_TYPE_RICH_TEXT = "RichText";

export const NOT_SUBMITTED = "NOT_SUBMITTED";
export const SCORE_BASED = "SCORE_BASED";
export const STANDARD_BASED = "STANDARD_BASED";
export const MYP_CRITERIA_BASED = "MYP_CRITERIA_BASED";

export const GRADING_VISIBILITY_SETTINGS = "GRADING_VISIBILITY_SETTINGS";

export const REGULAR = "REGULAR";
export const SPECIAL = "SPECIAL";
export const DEPENDENT = "DEPENDENT";
export const MYP_CRITERIA_TOTAL = "MYP_CRITERIA_TOTAL";
export const MYP_IB_DEFINED = "MYP_IB_DEFINED";
export const MYP_FINAL_GRADE = "MYP_FINAL_GRADE";
export const DP_IB_DEFINED = "DP_IB_DEFINED";

export const ALPHA = "ALPHA";
export const NUMERIC = "NUMERIC";
export const NUMERIC_VALUE = "NUMERIC_VALUE";
export const GRADE_VALUE = "GRADE_VALUE";

export const MAXIMUM = "MAXIMUM";
export const MINIMUM = "MINIMUM";
export const MIDDLE = "MIDDLE";

export const IB_PROGRAMS = "IB_PROGRAMS";

export const HOLIDAYS_AND_VACATIONS = "HOLIDAYS_AND_VACATIONS";
export const WHOLE_SCHOOL_EVENTS = "WHOLE_SCHOOL_EVENTS";

export const SCHOOL_BANNER_RECOMMENDED_RESOLUTION = "1200 X 200px";

// Media Queries
export const MOBILE_MEDIA_QUERY = "(max-width: 640px)";
export const TABLET_MEDIA_QUERY = "(max-width: 768px)";
export const TABLET_LANDSCAPE_MEDIA_QUERY = "(max-width: 1024px)";

//constants for new admin side-navigation

export const TOP_LEVEL_ID = "L1";
export const SECOND_LEVEL_ID = "L2";

//Sentral constants
export const SENTRAL = "SENTRAL";
export const ESF_SENTRAL_LOGIN = "ESF_SENTRAL_LOGIN";
export const CLOSE_SENTRAL_PORTAL_IFRAME = "CLOSE_SENTRAL_PORTAL_IFRAME";
export const FETCH_PLATFORM_URL = "FETCH_PLATFORM_URL";
export const FETCH_AUTH_CODE_URL = "FETCH_AUTH_CODE_URL";
export const QUEST_WEEK_SUBJECT = "Quest Week";

// StudentAlerts constants
export const STUDENT_ALERTS_BODY_WRAPPER_ID = "StudentAlertsBodyWrapper";

// Sentry Error messages
export const ROOT_CATEGORY_NAME_ALREADY_EXISTS =
  "ROOT_CATEGORY_NAME_ALREADY_EXISTS";

export const LOGGED_OUT_USER_ERROR =
  "Response not successful: Received status code 401";

// Learning course constants
export const BLUEPRINT_COURSE = "BLUEPRINT_COURSE";
export const TEACHER_COURSE = "TEACHER_COURSE";

export const KOGNITY = "KOGNITY";

// Bulk actions constant
export const BULK_ACTIONS = "BULK_ACTIONS";
export const STUDENT_BULK_ACTIONS = `STUDENT_${BULK_ACTIONS}`;
export const STAFF_BULK_ACTIONS = `STAFF_${BULK_ACTIONS}`;
export const CLASS_BULK_ACTIONS = `CLASS_${BULK_ACTIONS}`;
export const COURSE_BULK_ACTIONS = `COURSE_${BULK_ACTIONS}`;
export const ENTITY_BULK_ACTION_DECIDER = "ENTITY_BULK_ACTION_DECIDER";

// Placeholder role ids

export const USE_ACCOUNT_ROLE = "USE_ACCOUNT_ROLE";
export const USE_SCHOOL_ROLE = "USE_SCHOOL_ROLE";

// Bulk download pdf type constants
export const BULK_DOWNLOAD_STUDENT_SIGNIN_CODE =
  "BULK_DOWNLOAD_STUDENT_SIGNIN_CODE";

export const BULK_DOWNLOAD_FAMILY_INVITE_PDF =
  "BULK_DOWNLOAD_FAMILY_INVITE_PDF";

// Students Profile constants
export const STUDENT_PROFILE_TABS_NOMENCLATURE =
  "STUDENT_PROFILE_TABS_NOMENCLATURE";

// for email redirection Used in TodosModules and NavigationThunks
export const THIS_WEEK = "THIS_WEEK";

// Curriculum program type
export const SCHOOL = "SCHOOL";

// Student assignment footer dialogue actions
export const LEAVE_CONFIRM = "LEAVE_CONFIRM";
export const RESPONSE_PENDING = "RESPONSE_PENDING";
export const EVALUATION_PENDING = "EVALUATION_PENDING";
